import { useEffect, useState } from 'react';
import { supportsTransparentMov } from 'lib/utils/supports-transparent-mov';

interface TransparentVideoMedia {
  videoSrc?: string;
  webmVideoSrc?: string;
}

// Transparent .mov where the browser supports it, otherwise the .webm. Set after mount
// so the server never renders a src, which would start the download on every device.
export const useTransparentVideoSrc = (
  media: TransparentVideoMedia,
  enabled = true,
) => {
  const [src, setSrc] = useState<string>();

  useEffect(() => {
    if (!enabled) {
      setSrc(undefined);
      return;
    }
    setSrc(
      !supportsTransparentMov() && media.webmVideoSrc
        ? media.webmVideoSrc
        : media.videoSrc,
    );
  }, [enabled, media.videoSrc, media.webmVideoSrc]);

  return src;
};
